import React, { Component } from "react";

export interface IEnableUserRoleApprovalDetailProps {
  item: any;
}

export interface IEnableUserRoleApprovalDetailState {
  item: any;
}

class EnableUserRoleApprovalDetail extends Component<
  IEnableUserRoleApprovalDetailProps,
  IEnableUserRoleApprovalDetailState
> {
  constructor(props: IEnableUserRoleApprovalDetailProps) {
    super(props);
    this.state = {
      item: {},
    };
  }

  static getDerivedStateFromProps(
    nextProps: IEnableUserRoleApprovalDetailProps,
    prevState
  ) {
    if (nextProps.item) {
      return { item: JSON.parse(nextProps.item) };
    }
    return null;
  }

  render() {
    return (
      <React.Fragment>
        <div>
          <h6>Enable User Role Approval Detail</h6>
        </div>
      </React.Fragment>
    );
  }
}

export default EnableUserRoleApprovalDetail;
